/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const templateModule = require('@utils/template/templateModule');
const CmsContentService = require('./cmsContentService');
const cmsContentDirective = require('./cmsContentDirective');
const clickableCmsContentDirective = require('./clickableCmsContentDirective');

/**
 * Defines the module for the CMS utility dependencies.
 */
const cmsModule = angular
    .module('enervee_utils.cms', [
        commonModule.name,
        templateModule.name,
    ])
    .factory('CmsContentService', CmsContentService)
    .directive('cmsContent', cmsContentDirective)
    .directive('clickableCmsContent', clickableCmsContentDirective);

module.exports = cmsModule;
